module.exports = __webpack_public_path__ + "img/pointer.fedd8b46.png";